import client from '../apiClient';

export async function selectByOrderId (id) {
    let response = await client.get('/productOrderDetails/selectByOrderId' , {
        params : {
            id
        }
    })
    return response
}